import cc from 'store/util/createReduxConstant';

export const SET_SELECTED_LOCATIONS = cc('SET_SELECTED_LOCATIONS');
